export enum SharedReportSentDetailsEnum {
    mailingLists,
    recipients
}
